import React from 'react';
import { Card, CardBody, Table } from 'reactstrap';
import { useTranslation } from 'react-i18next';

// Per-org table at the bottom of the Overview tab.
// V1 columns: Org name (clickable), Completed %, On Time %, Preventive %.
// No goal coloring, no settings icon — per V1 scope.

const fmtPct = (v) => (v == null ? '—' : `${v.toFixed(1)}%`);

export default function OrganizationsTable({ rows, onOrgClick }) {
  const { t } = useTranslation();
  const sectionTitle = t('shared.global_org.overview.section_organizations', 'Organizations');

  return (
    <Card className="h-100">
      <CardBody>
        <div className="fw-semibold mb-3">{sectionTitle}</div>
        <Table responsive className="mb-0 align-middle">
          <thead>
            <tr>
              <th>{t('shared.global_org.overview.col_org', 'Organization')}</th>
              <th className="text-end">
                {t('shared.global_org.overview.col_completed_pct', 'Completed')}
              </th>
              <th className="text-end">
                {t('shared.global_org.overview.col_on_time_pct', 'On Time')}
              </th>
              <th className="text-end">
                {t('shared.global_org.overview.col_preventive_pct', 'Preventive')}
              </th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td colSpan={4} className="text-center text-muted py-3">
                  {t('shared.global_org.overview.no_data_yet', 'No data yet')}
                </td>
              </tr>
            ) : (
              rows.map((r) => (
                <tr key={r.subOrgId}>
                  <td>
                    <button
                      type="button"
                      className="btn btn-link p-0 text-decoration-none"
                      onClick={() => onOrgClick?.(r)}
                    >
                      {r.subOrgName}
                    </button>
                  </td>
                  <td className="text-end">{fmtPct(r.completedPct)}</td>
                  <td className="text-end">{fmtPct(r.onTimePct)}</td>
                  <td className="text-end">{fmtPct(r.preventivePct)}</td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </CardBody>
    </Card>
  );
}
